import {CanActivateFn, Router} from '@angular/router';
import {AuthService} from "../services/auth.service";
import {inject} from "@angular/core";

export const loginGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    // Se o usuário já estiver autenticado, redireciona para a home (ou outra página)
    router.navigate(['/']).then(() =>
      console.log('Navigated to home page')
    );
    return false;
  }

  return true;
};
